import { FC, useEffect, useState } from 'react';
import { combineLatest } from 'rxjs';
import { ProductState } from 'src/constants';

import { observeProductSupplier, observeProducts } from 'src/utils/firebase/firebase-short-cut';

import { useTitle } from 'src/hooks/useTitle';

import ProductTable, { RowData } from './ProductTable/ProductTable';

const Product: FC = () => {
  useTitle('상품 관리');
  const [rowData, setRowData] = useState<RowData[]>([]);
  const [selectedStates, setSelectedStates] = useState<ProductState[]>(['stock', 'out-of-stock']);

  useEffect(() => {
    if (selectedStates.length === 0) {
      setRowData([]);
      return;
    }
    const productSubscription = observeProducts([['state', 'in', selectedStates]]);
    const productSupplierSubscription = observeProductSupplier([['deletedAt', '==', null]]);
    const subscription = combineLatest([productSubscription, productSupplierSubscription]).subscribe(
      ([products, productSuppliers]) => {
        const rowData: RowData[] = products.map((product) => {
          const productSupplier = productSuppliers.find(
            (productSupplier) => productSupplier._id === product.supplierId
          );
          return {
            ...product,
            productSupplierName: productSupplier?.name ?? 'unknown',
          };
        });
        setRowData(rowData);
      }
    );

    return () => subscription.unsubscribe();
  }, [selectedStates]);

  return <ProductTable rowData={rowData} selectedStates={selectedStates} setSelectedStates={setSelectedStates} />;
};

export default Product;
